<div class="cancel-page">
  <div class="cancel-card">
    <div class="cancel-icon">
      <i class="pi pi-times-circle"></i>
    </div>
    <h2 class="cancel-title">Assinatura não concluída</h2>
    <p class="cancel-desc">
      Você cancelou o processo de pagamento. Seu plano atual não foi alterado.
    </p>
    <p-button
      label="Voltar ao dashboard"
      icon="pi pi-home"
    class="p-button-cancel"
      (onClick)="goToDashboard()" />
  </div>
</div>
